import React from 'react';
import styled from 'styled-components';

import { swatches } from '../../styles/theme';
import Button from '../global/Button';
import InnerWrapper from '../global/InnerWrapper';
import NavLink from '../global/NavLink';
import H1 from '../global/typography/H1';
import P from '../global/typography/P';

const BreakpointMobile = '(max-width: 950px)';

const Wrapper = styled.section`
  background-color: ${swatches.gray.dark};
  color: ${swatches.white};
  padding: 60px 0;
  position: relative;

  @media ${BreakpointMobile} {
    padding: 32px 0;
  }
`;

const CalloutBox = styled(InnerWrapper)`
  background-color: ${swatches.white};
  color: ${swatches.black};
  padding: 40px;

  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 20px;

  @media ${BreakpointMobile} {
    flex-direction: column;
  }
`;

const TextWrapper = styled.div``;

const MapPin = styled.img`
  width: 51px;
  height: 67px;
`;

const UnboundImage = styled.img`
  max-width: 268px;
  margin-bottom: -40px;

  @media ${BreakpointMobile} {
    margin-bottom: 0px;
  }
`;

const LocatorButton = styled(Button)`
  height: 40px;
  width: 200px;
`;

const LocatorCallout = () => (
  <Wrapper>
    <CalloutBox>
      <MapPin src="home/map-pin.png" />
      <TextWrapper>
        <H1>Locate the solution you need</H1>
        <P>Find a service provider or where to buy any of our products.</P>
      </TextWrapper>
      <UnboundImage src="home/wtb-heaters.png" />
      <NavLink to="/locator">
        <LocatorButton>Let's get started</LocatorButton>
      </NavLink>
    </CalloutBox>
  </Wrapper>
);

export default LocatorCallout;
